import { render } from "./OptionsTags.vue?vue&type=template&id=0f8f537a"
import script from "./OptionsTags.vue?vue&type=script&lang=js"
export * from "./OptionsTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__